import { useState, useEffect } from 'react';

/**
 * Returns the current timestamp (ms), updated every `intervalMs` while `active` is true.
 * All timer displays in a component should share a single useTick() call for efficiency.
 */
export function useTick(active: boolean, intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!active) return;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [active, intervalMs]);

  return now;
}
